import { each, isUndefined } from 'lodash';
import { securityTypes } from 'common/constants';
import { SECURITY_NAME_ALIAS, SECURITY_TYPE_ROW_NUMBER } from 'common/constants/cap-table';
import { CapTableCell } from '../components/captable-table/CaptableTable.props';

export const NONE_AS_COMMON_VALUE = '__none_as_common__';
export const NONE_AS_COMMON_OPTION = {
  id: NONE_AS_COMMON_VALUE,
  name: 'None (as Common)',
  columnLegend: '',
};

export const isNoneAsCommonValue = (value: unknown) => value === NONE_AS_COMMON_VALUE;
export const isMissingUnderlyingSecurityValue = (value: unknown) =>
  [null, undefined, '', '0', 0].includes(value as string | number | null | undefined);

const underlyingType = {
  [securityTypes.OPTION]: securityTypes.COMMON_STOCK,
  [securityTypes.WARRANT]: securityTypes.PREFERRED_STOCK,
};

export const securityTypeValue = (columnLegend: string, cells: Record<string, CapTableCell>) => {
  const securityTypeCell = cells[columnLegend + SECURITY_TYPE_ROW_NUMBER];
  return securityTypeCell && Number(securityTypeCell.value);
};

export const getRequiredSecurityName = (parentSecurityType: number) => {
  const securityTypeIndex = underlyingType[parentSecurityType as keyof typeof underlyingType] - 1;
  return securityTypes.LIST[securityTypeIndex];
};

export const getSecurityType = (secRef: string, cells: Record<string, CapTableCell>): number | undefined => {
  let result;

  each(cells, cell => {
    if (cell.alias === SECURITY_NAME_ALIAS && cell.securityRef === secRef) {
      const securityType = cells[cell.columnLegend! + SECURITY_TYPE_ROW_NUMBER];

      if (securityType?.value) {
        result = securityType.value;
      }
    }
  });

  return result;
};

export const getOptions = ({ securityType, cells }: { securityType: number; cells: Record<string, CapTableCell> }) => {
  const securityNames: { id: string; name: string; columnLegend: string }[] = [];

  each(cells, cell => {
    const validCell = cell && cell.alias === SECURITY_NAME_ALIAS;
    const validColumn = !isUndefined(cell.columnId);

    if (validCell && validColumn) {
      const { securityRef: id, value: name, columnLegend: legend } = cell;
      const columnLegend = legend || '';
      const cellSecurityType = securityTypeValue(columnLegend, cells);

      const isPreferredOrCommon = [securityTypes.PREFERRED_STOCK, securityTypes.COMMON_STOCK].includes(
        cellSecurityType
      );

      const isCommon = cellSecurityType === securityTypes.COMMON_STOCK;

      if (
        (securityType === securityTypes.WARRANT && isPreferredOrCommon)
        || (securityType === securityTypes.OPTION && isCommon)
      ) {
        securityNames.push({ id: id as string, name: name as string, columnLegend: columnLegend as string });
      }
    }
  });

  return securityNames;
};

export default getOptions;
